export default "__VITE_ASSET__CkO$u2UE__"